import {
    addCompanyRequest,
    deleteCompanyRequest,
    editCompanyRequest,
    getCompanyListRequest,
    getCompanyRequest,
    getAdvertsListRequest,
} from '../../../services/network/company';

class CommonCompanyService {
    async addCompany(companyData) {
        return await addCompanyRequest(companyData);
    }

    async getCompany(id) {
        return await getCompanyRequest(id);
    }

    async getCompanyList(payload) {
        return await getCompanyListRequest(payload);
    }

    async editCompany(updates) {
        return await editCompanyRequest(updates);
    }

    async deleteCompany(id) {
        return await deleteCompanyRequest(id);
    }

    async getAdvertsList(payload) {
        return await getAdvertsListRequest(payload);
    }
}

export const CompanyService = new CommonCompanyService();
